// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__qtoqm","icon":"LogoutButton_icon__Rwct8"};